import moment from 'moment/moment'

export const getMomentFromFormattedDate = (date) => moment(date, 'DD/MM/YYYY HH:mm:ss')

export const getDateFromFormattedDate = (date) => getMomentFromFormattedDate(date)?.toDate()

export const getDateStringFromFormattedDateStr = (date) => {
  const formattedDate = getMomentFromFormattedDate(date)
  if (formattedDate.isValid()) return formattedDate.format('YYYY-MM-DD')
  return ''
}

export const getFormattedDateStrFromDateStr = (date) => moment(date)?.format('DD/MM/YYYY')

export const getOnlyDateFromFormattedDateStr = (date) => getMomentFromFormattedDate(date)?.format('DD/MM/YYYY')

export const isValidDate = (date) => moment(date, 'DD/MM/YYYY')?.isValid()

export const isNormalFormatValidDate = (date) => moment(date, 'DD/MM/YYYY')?.isValid()

export const getDateFromStringDate = (date) => date?.substr(0, 10)

export const getDiffTime = (date) => moment().diff(getMomentFromFormattedDate(date), 'years')

export const getAgeFromBirthDateStr = (date) => moment().diff(getMomentFromFormattedDate(date), 'years')

export const getDateStringFromFormattedHDateStr = (date) => getMomentFromFormattedDate(date)?.format('YYYY-MM-DD HH:mm:ss')

export const getDateStringFromUsableDateStr = (date) => getMomentFromFormattedDate(date)?.format('DD/MM/YYYY [às] HH:mm:ss')

export const getDateStringFromUsableDateStrWithoutSecond = (date) => getMomentFromFormattedDate(date)?.format('DD/MM/YYYY [às] HH:mm')

export const checkInitialDateIsBefore = (startDate, endDate) => {
  const initDate = getMomentFromFormattedDate(startDate)
  const endsDate = getMomentFromFormattedDate(endDate)
  return initDate.isSameOrBefore(endsDate)
}
export const checkInitialDate = (startDate) => {
  const initDate = getMomentFromFormattedDate(startDate)
  const initialYear = moment('2020-01-01')
  return initDate.isSameOrBefore(initialYear)
}
